import template from './insuranceDetails.html';
import controller from './insuranceDetailsCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    clientInfo: '<',
    modalInstance: '<',
    insuranceData: '<',
    getInsuranceDetails: '&',
  },
};
